import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Typography, CircularProgress, Button, Menu, MenuItem } from '@mui/material';
import { debounce, isArray } from "lodash";
import {
  getBookingsMatrix,
} from 'redux/actions/ReportsAction';
import {
  getDownLoadList,
  getReservationList,
} from 'redux/actions/reservationAction';
import { fetchCompanyList,fetchParentCompanys } from "redux/actions/companyAction";
import { getServiceCity } from "redux/actions/UserServiceCity";
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import CommonButton from 'components/commonButton/CommonButton';
import CommonTable from 'components/commonTable/CommonTable';
import Loader from 'components/loader/Loader';
import CommonDateRangePicker from "components/commonDateRangePicker/CommonDateRangePicker";
import BillingFilter from 'pages/operation/billing/billingFlow/billingFilter/BillingFilter';
import CommonFilter from 'components/commonFilter/CommonFilter';
import { getDateFormat, handlePermissions } from 'utils/utils';
import CommonReportCard from 'pages/reports/CommonReportCard';
import { optionsBar,reportFilterOptions } from 'pages/reports/revenue/DummyDataReport';
import { bookingFilterData, breadcrumbPaths } from './BookingDummyData';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { requestBookingReportApi } from 'services/BookingReportService';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";

function BookingReport() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [status, setStatus] = useState([]);
  const [location, setLocation] = useState([]);
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
  const [dateFrom, setDateFrom] = useState(getDateFormat(thirtyDaysAgo,"reservationDateFormat"));
  const [dateTo, setDateTo] = useState(getDateFormat(new Date(),"reservationDateFormat"));
  const [isRequestingReport, setIsRequestingReport] = useState(false);

  const barChartData =
    useSelector((state) => state?.getBookingMatrix?.bookingMatrix?.data) || {};
  const barChartLoader = useSelector(
    (state) => state?.getBookingMatrix?.loading
  );
  const bookingReportData = useSelector(
    (state) => state.getReservationList?.reservationList?.data
  );

  const bookingLoader = useSelector(
    (state) => state.getReservationList?.loading
  );

  const totalCount = barChartData?.datasets?.[0]?.total;
  const profileData = JSON?.parse(localStorage.getItem('user'));
  const role = localStorage.getItem('role');
  const locationData = profileData?.Company?.ServiceCity?.id
  const [billingFilter, setBillingFilter] = useState({
    companyName: {},
    parentCompanyName: {},
    city: {},
  });

  let bookingReportPayload = {
    page: page,
    pageSize: rowsPerPage,
    status: status,
    location: location,
    dateTo: dateTo,
    dateFrom: dateFrom,
    city: role !== 'adminCompany'?locationData :billingFilter?.city?.value|| '',
    report: true,
    parentCompany: billingFilter?.parentCompanyName?.value || '',
    companyId: billingFilter?.companyName?.value|| '',
  };

  let BookingGraph = {
    status: status,
    location: location,
    dateTo: dateTo,
    dateFrom: dateFrom,
    city: role !== 'adminCompany'?locationData :billingFilter?.city?.value,
    parentCompany: billingFilter?.parentCompanyName?.value,
    companyId: billingFilter?.companyName?.value,
  };

  useEffect(() => {
    dispatch(getBookingsMatrix(BookingGraph));
    dispatch(getReservationList(bookingReportPayload));
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getReservationList({ ...bookingReportPayload, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getReservationList({
        ...bookingReportPayload,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  const onSelectDateRange = (newValue) => {
    setPage(0);
    if (newValue === null || newValue === 0) {
      setDateFrom('');
      setDateTo('');
      bookingReportPayload = {
        ...bookingReportPayload,
        dateFrom: '',
        dateTo: '',
        page:0
      };
    } else {
      setDateFrom(getDateFormat(newValue[0], 'reservationDateFormat'));
      setDateTo(getDateFormat(newValue[1], 'reservationDateFormat'));
      bookingReportPayload = {
        ...bookingReportPayload,
        dateFrom: getDateFormat(newValue[0], 'reservationDateFormat'),
        dateTo: getDateFormat(newValue[1], 'reservationDateFormat'),
        page:0
      };
    }
    dispatch(getReservationList(bookingReportPayload));
    dispatch(getBookingsMatrix(bookingReportPayload));
  };

  //Filter Reset
  const onFilterChange = (val) => {
    const defaultStatus = [
      'booked',
      'alloted',
      'dispatched',
      'onGoing',
      'completed',
      'cancelled'
    ];
    const defaultLocation = ['rental', 'airport', 'outStation'];
    const filterStatus = val.filter((status) => {
      return defaultStatus.includes(status);
    });

    const filterLocations = val.filter((DutyType) => {
      return defaultLocation.includes(DutyType);
    });

    setLocation(filterLocations);
    setStatus(filterStatus);
    setPage(0);

    const bookingReportPayloads = {
      ...bookingReportPayload,
      status: filterStatus?.toString(),
      location: filterLocations?.toString(),
      page: 0,
    };
    dispatch(getReservationList(bookingReportPayloads));
    dispatch(getBookingsMatrix(bookingReportPayloads));
  };

  // ---Reset Filter---
  const onRestFilter = () => {
    dispatch(
      getReservationList({ ...bookingReportPayload, status: '', location: '', page: 0 })
    );
    dispatch(
      getBookingsMatrix({ ...bookingReportPayload, status: '', location: '', page: 0 })
    );
    setStatus([]);
    setLocation([]);
    setPage(0);
  };

  // AutoComplete Search Added
  let filterData = {
    search: "",
  };
  useEffect(() => {
    dispatch(
      fetchCompanyList(filterData, {
        searchType: "globalSearch",
        loader: "backDropLoader",
      })
    );
    dispatch(
      fetchParentCompanys(filterData, {
        searchType: "globalSearch",
        loader: "backDropLoader",
      })
    );
    dispatch(getServiceCity());
  }, []);

  const companyTableData = useSelector(
    (state) => state?.userCompany?.companyList?.body
  );
  const locationOptions = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );

  const parentCompanyList = useSelector(
    (state) => state?.parentCompanyList?.parentCompanyList?.body
  );

  const parentCompanyListOption =
    parentCompanyList?.length > 0 &&
    parentCompanyList?.map((val) => {
      return { value: val?.id, label: val.name };
    });

  const companyOption =
    companyTableData?.length > 0 &&
    companyTableData?.map((val) => {
      return { value: val?.id, label: val.name };
    });

  const cityOption =
    locationOptions?.length > 0 &&
    locationOptions?.map((val) => {
      return { value: val?.id, label: val.name };
    });

    const handleFilter = (name, newValue) => {
      setBillingFilter((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));
  
      if (name === "companyName") {
        const bookingReportPayloads = {
          ...bookingReportPayload,
          companyId: newValue?.value,
          page: 0,
        };
        dispatch(getReservationList(bookingReportPayloads));
        dispatch(getBookingsMatrix(bookingReportPayloads));
      } else if (name === "city") {
        const bookingReportPayloads = {
          ...bookingReportPayload,
          city: newValue?.value,
          page: 0,
        };
        dispatch(getReservationList(bookingReportPayloads));
        dispatch(getBookingsMatrix(bookingReportPayloads));
      }else if (name === "parentCompanyName") {
        const bookingReportPayloads = {
          ...bookingReportPayload,
          parentCompany: newValue?.value,
          page: 0,
        };
        dispatch(getReservationList(bookingReportPayloads));
        dispatch(getBookingsMatrix(bookingReportPayloads));
      }
    };

     //company Auto suggestion
  const onHandleAutoSuggestion = debounce((event, value, fieldName) => {
    if (event?.type === "change") {
      if (fieldName === "companyName" && value) {
        dispatch(
          fetchCompanyList(
            { ...filterData, search: value },
            { searchType: "globalSearch", loader: "backDropLoader" }
          )
        );
      } else {
        dispatch(
          fetchCompanyList(filterData, {
            searchType: "globalSearch",
            loader: "backDropLoader",
          })
        );
      }

      if(fieldName === "parentCompanyName" && value) {
        dispatch(
          fetchParentCompanys(
            { ...filterData, search: value },
            { searchType: "globalSearch", loader: "backDropLoader" }
          )
        );
      } else {
        dispatch(
          fetchParentCompanys(filterData, {
            searchType: "globalSearch",
            loader: "backDropLoader",
          })
        );
      }
    }
  }, 500);

  const onClick = () => {
    const reservationPayload = {
      ...bookingReportPayload,
      export: true,
      report:false,
    };

    console.log('reservationPayload>>>>>>', reservationPayload)
    dispatch(getDownLoadList(reservationPayload));
  };

  //roles and permissions 
  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const reportBookingRoleEnum = roleAndPermissionEnum.reports

  const accessForall = handlePermissions(roleAndPermissions, reportBookingRoleEnum.moduleKey, {defaultAllAccess: reportBookingRoleEnum.all, customAccess: reportBookingRoleEnum.add});

  const accessForOnlyView = handlePermissions(roleAndPermissions, reportBookingRoleEnum.moduleKey, {customAccess: reportBookingRoleEnum.view});

  const accessForBookingDownload = handlePermissions(roleAndPermissions, reportBookingRoleEnum.moduleKey, { customAccess: reportBookingRoleEnum?.subModules?.booking?.download });
  
  const onRequestReport = async (format) => {
    setIsRequestingReport(true);

    console.log('bookingReportPayload', bookingReportPayload);
    setIsRequestingReport(false);
  try {
    const payload = {
      startDate: dateFrom,
      endDate: dateTo,
      reportType: "B2B_TRIP_REPORT",
      reportFormate: format,
      filters: {
        location: bookingReportPayload?.city,
        type: bookingReportPayload?.location && isArray(bookingReportPayload?.location) ? bookingReportPayload?.location.join(',') : '',
        companyId: bookingReportPayload?.companyId,
        parentCompany: bookingReportPayload?.parentCompany,
        status: bookingReportPayload?.status && isArray(bookingReportPayload?.status) ? bookingReportPayload?.status.join(',') : ''
      }
    };
    const response = await requestBookingReportApi(payload);
    if (response.success) {
      toast.success("Report request submitted successfully");
      navigate("/report-generate");
    } else {
      toast.error(response?.message || "Failed to request report");
    }
  } catch (error) {
    toast.error("Error requesting report");
  }
   finally {
    setIsRequestingReport(false);
  }
};

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelectFormat = (format) => {
    onRequestReport(format);
    handleClose();
  };

  return (
    <Box>
      <Box className="mtb30">
        <CommonBreadCrumb paths={breadcrumbPaths} />
        <Grid container>
        <Grid
          item
          container
          gap={2}
          lg={7}
          md={12}
          xs={12}
          flexWrap={{ xs: "wrap", sm: "wrap", md: "nowrap", lg: "nowrap" }}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className=""
        >
          {reportFilterOptions(cityOption,parentCompanyListOption,companyOption) &&
            reportFilterOptions(cityOption,parentCompanyListOption,companyOption)?.map(
              (formData, index) => (
                <Grid
                  item
                  lg={5}
                  md={12}
                  xs={12}
                  key={index}
                  className="misAutoComplete"
                >
                  <BillingFilter
                    billingFilterValue={billingFilter}
                    setBillingFilter={setBillingFilter}
                    handleFilter={handleFilter}
                    formData={formData}
                    onHandleAutoSuggestion={onHandleAutoSuggestion}
                  />
                </Grid>
              )
            )}
        </Grid>
        <Grid
          container
          item
          lg={5}
          md={12}
          xs={12}
          direction="row"
          sx={{marginTop:{lg:'10px',md:'0px',sm:'0px',xs:'0px'},justifyContent:{lg:'flex-end',md:'flex-start',sm:'flex-start',xs:'flex-start'}}}
          alignitem="center"
        >
          <Grid item lg={12} xs={12} className="justifyEnd" style={{ marginTop: "24px"}}>
            <CommonDateRangePicker
              onSelectDateRange={onSelectDateRange}
              dateFrom={dateFrom}
              dateTo={dateTo}
            />
            <CommonFilter
              defaultStatus={status}
              filterdata={bookingFilterData}
              onFilterChange={onFilterChange}
              onRestFilter={onRestFilter}
              defaultLocation={location}
            />
          </Grid>
        </Grid>
      </Grid>
      </Box>
      {barChartLoader ? (
        <Loader />
      ) : (
        <CommonReportCard
          barChartData={barChartData}
          loader={barChartLoader}
          count={totalCount}
          option={optionsBar}
        />
      )}
      <Box className="justifyBetween pb10">
        <Typography variant="body1" className="colorBlack">
          Booking Reports
        </Typography>
        {accessForBookingDownload && 
        <div style={{ display: "flex", gap: "20px" }}>
        <Button
          onClick={handleClick}
          disabled={isRequestingReport}
          sx={{
            backgroundColor: '#1976d2',
            borderRadius: '8px',
            color: '#fff',
            textTransform: 'none',
            paddingX: 2,
            paddingY: 1,
            '&:hover': {
              backgroundColor: '#1565c0',
            },
            '&.Mui-disabled': {
              backgroundColor: '#9e9e9e',
              color: '#fff',
            },
          }}
        >
          {isRequestingReport ? (
            <CircularProgress
              size={20}
              sx={{ color: "#fff" }}
            />
          ) : (
            "Request Report"
          )}
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            sx: { width: anchorEl ? anchorEl.offsetWidth : "auto" }, // match button width
          }}
        >
          <MenuItem onClick={() => handleSelectFormat("csv")} sx={{ width: "100%",  fontSize: "14px" }}>
            Excel/CSV
          </MenuItem>
          <MenuItem onClick={() => handleSelectFormat("pdf")} sx={{ width: "100%",  fontSize: "14px" }}>
            PDF
          </MenuItem>
        </Menu>
        <CommonButton
          name="Send Report to mail"
          btnClass="btnSm btnYellow"
          onClick={onClick}
        />
      </div>}
      </Box>
      {bookingLoader ? (
        <Loader />
      ) : (
        <CommonTable
          data={bookingReportData}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      )}
    </Box>
  );
}

export default BookingReport;
